module.exports = __webpack_public_path__ + "img/loader.3cf9a446.svg";